<fa-icon (click)="showTips()" [icon]="faLightbulb" class="tips"></fa-icon>